module.exports = __webpack_public_path__ + "img/access-facebook-ads_bg2.4039dc20.png";